import { Box, Typography } from "@mui/material";
import SecureVolumeDashboard from "../../components/reports/components/SecureVolumeDashboard";

export default function SecureVolumePage() {
  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h4" gutterBottom>
        Säkra Volym
      </Typography>
      <SecureVolumeDashboard />
    </Box>
  );
}
